document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('[data-header]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobile = document.querySelector('[data-mobile-nav]');

  function closeMenu() {
    if (!toggle || !mobile) return;
    mobile.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('menu-open');
  }

  function updateHeader() {
    if (!header) return;
    header.classList.toggle('ss-header--solid', window.scrollY > 24);
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  if (toggle && mobile) {
    toggle.addEventListener('click', function () {
      const willOpen = mobile.hidden;
      mobile.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', willOpen ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('menu-open', willOpen);
    });

    mobile.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      const section = select.closest('[data-product-section]');
      const option = select.options[select.selectedIndex];
      if (!section || !option) return;

      const price = section.querySelector('[data-product-price]');
      const submit = section.querySelector('[data-add-to-cart]');
      const available = option.dataset.available === 'true';

      if (price) {
        const compare = option.dataset.comparePrice;
        price.innerHTML = (compare && compare !== option.dataset.price ? '<s>' + compare + '</s>' : '') +
          '<span>' + option.dataset.price + '</span>';
      }
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const reveals = document.querySelectorAll('.ss-section, .ss-product-hero');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function (element) { observer.observe(element); });
  }
});
